import React from 'react';
import { RootState } from '../../../../../store';
import ComponentCard from '../ComponentCard/ComponentCard';
import Loader from '../../../../../components/Loader/Loader';
import { BusinessUnit, Centre, Series } from '@cambridgeassessment/lib-ee-commons';
import { useSelector } from 'react-redux';
import SavingOverlay from '../SavingOverlay/SavingOverlay';
import { StyledComponentsListWrapper } from './ComponentsList.styles';

interface Props {
  businessUnitId?: BusinessUnit['id'];
  seriesId?: Series['id'];
  centreId?: Centre['id'] | null;
  learnerNumber?: string | null;
}

const ComponentsList: React.FC<Props> = ({ businessUnitId, seriesId, centreId, learnerNumber }) => {
  const { items, isLoading, isSaving } = useSelector((state: RootState) => state.replacementFiles);

  if (!businessUnitId || !seriesId || !centreId) {
    return null;
  }

  return (
    <StyledComponentsListWrapper>
      {items.map((component, index) => (
        <ComponentCard
          isAllSelected={component.isAllSelected}
          isAllAbsent={component.isAllAbsent}
          key={component.component.number}
          componentIndex={index}
          component={component}
          businessUnitId={businessUnitId}
          seriesId={seriesId}
          centreId={centreId}
          learnerNumber={learnerNumber || null}
        />
      ))}
      {isLoading && <Loader />}
      {isSaving && <SavingOverlay />}
    </StyledComponentsListWrapper>
  );
};

export default ComponentsList;
